var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.disabled ? 'cursor: not-allowed;' : '')},[_c('ckeditor',{attrs:{"config":_vm.config,"disabled":_vm.disabled,"editor":_vm.editor,"value":_vm.valueComputed},on:{"input":_vm.onInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }